export const crew = {
  banner: {
    alt: "Banner drawing",
  },
  basicInfo: {
    heading: "Basic info",
  },
  crewmateCard: {
    you: "You",
    coach: "Your coach",
  },
  editProfile: {
    cancel: "Cancel",
    heading: "Edit Profile",
    save: "Save",
  },
  fieldPrompts: {
    coachExpertise: "Expertise",
    currentlyTrying: "I am currently trying to conceive by...",
    goal: "I'm here to...",
    moreAboutMe: "More about me",
    moreAboutMePlaceholder: "Tell your crew about yourself...",
  },
  funFacts: {
    heading: "Fun facts",
    tripTomorrow: "If I could take a trip tomorrow it would be to",
    typicalWeek: "A typical weekday for me looks like",
    whoIAm: "Who I am and where I hail from",
  },
  header: {
    coachMessageCta: "Message coaching team",
    crewMessageCta: "Message crew",
    description: "A coach, {{crewCount}} friends, and only one of you!",
    descriptionNotMatched: "We’re working on matching you.",
    descriptionUpsell: "A coach, community of peers, and you!",
    title: "Your Conceive Crew",
  },
  myJourney: {
    heading: "My journey",
    gratefulForPrompt: "I am grateful for...",
    madlib:
      "I am currently trying to conceive <Highlight>by {{ currentlyTrying }}</Highlight>. I've been trying for <Highlight>{{ duration }}</Highlight> and have tried <Highlight>{{ previouslyTried }}</Highlight>. I am doing this <Highlight>{{partnerClause}}</Highlight>, and I am here to <Highlight>{{goal}}</Highlight>. I am grateful for <Highlight>{{gratefulFor}}</Highlight>.",
    partner: "",
    partner_solo: "by myself",
    partner_named: "with my partner, {{partnerName}}",
    partner_anonymous: "with my partner",
    partnerNamePrompt: "Partner's first name",
    partnerTypePrompt: "I am on this journey with...",
    previouslyTriedPrompt: "I have previously tried to conceive by...",
    tryingSincePrompt: "I've been trying since",
  },
  noProfile: {
    cta: "Create my profile",
    currentUser: {
      description:
        "This is where the members of your Crew will learn about you and your journey. It’s empty now, but only takes a few minutes to fill out. Introduce yourself to your Crew by filling out your profile now!",
      heading: "Welcome to your Profile",
    },
    namePlaceholder: "This member",
    otherUser: {
      description:
        "{{firstName}} hasn’t set up their profile yet, so check back soon to learn more.",
      heading: "{{firstName}} is still getting settled.",
    },
  },
  notMatched: {
    contactUs: "Contact us",
    description:
      "We’re still working on matching you with the perfect Crew. We’ll send you an update when everything is all set! Any issues? Feel free to contact us.",
    subheading: "We're working on matching you.",
  },
  pageTitle: "Your Crew",
  profileHeader: {
    journeySince: "Journey started {{since}} ago",
  },
  profilePicture: {
    alt: "Profile picture",
    heading: "Profile picture",
    remove: "Remove",
    upload: "Upload",
  },
  upsell: {
    altPlusUpsell: "Screenshot of premium crew experience",
  },
};
